<ejs-sidebar id="sidebar-menu" #sidebarInstance type='Over' [width]='width' [position]='position'
             style="visibility: hidden" [enableGestures]="false" [showBackdrop]=true>

  <div class="offcanvas-close mt-n1 pr-5" style="float:right; padding: 48px;">
    <a href="javascript:;" class="btn btn-xs btn-icon btn-light btn-hover-primary" id="kt_quick_panel_close"
       (click)="closeSidebar()">
      <i class="ki ki-close icon-xs text-muted"></i>
    </a>
  </div>

  <div class='p-15'>
    <h2 *ngIf="!orderItemInput">Add Order Item</h2>
    <h2 *ngIf="orderItemInput">Update Order Item</h2>

    <form id="formId" [formGroup]="orderItemForm" #formDir="ngForm" class="form-horizontal" novalidate=""
          style="margin-top: 16px;">

      <div class="form-group sf-outline-input mb-10" [class.hide-label]="orderItemForm.controls.order_item_parent_code.value == ''">
        <ejs-dropdowntree formControlName="order_item_parent_code" id='order_item_parent_code' allowMultiSelection='false'
                          [fields]='orderItemsField' placeholder='Parent Order Item' floatLabelType="Auto" cssClass="e-filled"
                          (blur)="orderItemForm.controls.order_item_parent_code.markAsTouched()"></ejs-dropdowntree>
        <div>Note: If a parent order item isn't selected, the new order item will be added as a parent</div>
      </div>

      <div class="form-group sf-outline-input mb-10">
        <ejs-textbox id="order_item_name" placeholder="Order Item Name *" cssClass="e-filled"
                     formControlName="order_item_name" floatLabelType="Auto"
                     (blur)="orderItemForm.controls.order_item_name.markAsTouched()"
        ></ejs-textbox>
        <div *ngIf="orderItemForm.controls.order_item_name.errors">
          <div
            *ngIf="orderItemForm.controls.order_item_name.errors.required && orderItemForm.controls.order_item_name.touched"
            class="e-error">
            Order Item Name is required.
          </div>
        </div>
      </div>

      <div class="form-group sf-outline-input mb-10">
        <ejs-textbox id="description" [multiline]="true" placeholder="Description" cssClass="e-filled"
                     formControlName="description" floatLabelType="Auto"
                     (blur)="orderItemForm.controls.description.markAsTouched()"
        ></ejs-textbox>
        <div *ngIf="orderItemForm.controls.description.errors">
          <div *ngIf="orderItemForm.controls.description.errors.maxlength && orderItemForm.controls.description.touched"
               class="e-error">
            Description cannot be more than 200 characters
          </div>
        </div>
      </div>


      <div *ngIf="orderItemForm.invalid" class="e-error">Please fill all fields</div>
      <div *ngIf="error$ | async as error" class="e-error">{{error.error.message}}</div>

      <div class="my-10 pb-20">
        <button id="resetbtn"
                class="btn btn-outline-secondary text-uppercase font-weight-bold px-15 py-5 float-right btn-block mb-5"
                type="button"
                data-ripple="true" (click)="clear()">Clear
        </button>
        <button *ngIf="!orderItemInput" id="addSubmit"
                class="btn btn-primary text-uppercase font-weight-bold px-15 py-5 float-right btn-block" type="submit"
                (click)="onAddUpdateDeliverableInput(orderItemForm)" [disabled]="formSent" data-ripple="true"> Add
          Order Item
        </button>
        <button *ngIf="orderItemInput" id="updateSubmit"
                class="btn btn-primary text-uppercase font-weight-bold px-15 py-5 float-right btn-block" type="submit"
                (click)="onAddUpdateDeliverableInput(orderItemForm, true)" [disabled]="formSent" data-ripple="true">
          Update Order Item
        </button>
      </div>
    </form>
  </div>
</ejs-sidebar>

<ejs-dialog #clearModal [buttons]='dltButtons' header='Are you sure?' animationSettings='none' showCloseIcon='true'
            width='25%' [visible]='false'>
  <ng-template #content>
    <p>This action will clear all form fields.</p>
  </ng-template>
</ejs-dialog>
